import React from 'react';
import { Badge, BadgeProps } from '@doveit/bricks';
import { taskStatusColors, taskStatusIcons } from '../../constants';
import { taskStatusLabels } from '../../../labels';
import { TaskStatus } from '../../../domain/types';

export interface TaskStatusBadgeProps extends React.AriaAttributes {
  status: TaskStatus,
  emphasis?: BadgeProps['emphasis'],
  size?: BadgeProps['size'],
  showIcon?: boolean,
}

const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({
  status,
  size,
  emphasis,
  showIcon,
  ...rest
}) => (
  <Badge
    aria-label="Badge stato attività"
    {...rest}
    emphasis={emphasis}
    label={taskStatusLabels[status]}
    color={taskStatusColors[status]}
    icon={showIcon ? taskStatusIcons[status] : undefined}
    size={size}
  />
);

export default TaskStatusBadge;
